import events from "@mongez/events";
import { Cart } from "core/cart";
import { Product, ShopProduct } from "core/catalog";

export const CartEvents = {
  CART_ITEM_UPDATED: "cart.item-updated",
  CART_ITEM_REMOVED: "cart.item-removed",
  CART_CLEARED: "cart.cleared",
};

type CartUpdateEventData = {
  cart: Cart;
  product: Product | ShopProduct;
};

type CartRemoveEventData = {
  product: Product | ShopProduct;
  cart: Cart;
};

/**
 * Trigger cart item updated event
 */
export function triggerCartUpdated(data: CartUpdateEventData) {
  events.trigger(CartEvents.CART_ITEM_UPDATED, data);
}

/**
 * Trigger cart item removed event
 */
export function triggerCartRemoved(data: CartRemoveEventData) {
  events.trigger(CartEvents.CART_ITEM_REMOVED, data);
}

/**
 * Trigger cart cleared event
 */
export function triggerCartCleared() {
  events.trigger(CartEvents.CART_CLEARED);
}
